<div class="section" >
    <div class="chart">
      <div>
        <div class="title">{{Title}}</div>
        <div class="sub-title">{{Title}} collected from different platforms</div>
     </div>

       </div>
       <div class="canvas">
        <canvas [id]="'canvas__'+id" style="margin-top: 10px; width: 100%;"  width="500px" height="263"></canvas>
       </div>
      
</div>       


